import { DatePicker, Input, TextArea } from "common/InputForm";
import useButtonLoader from "hooks/useButtonLoader";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createNotificationAPI } from "services/notification";
import { toast } from "sonner";
import dayjs from 'dayjs';
import { IoChevronBack } from "react-icons/io5";

const CreateNotification = () => {
  const navigate = useNavigate();

  //***************************** Handle All State ******************************//
  const [buttonLoader, setButtonLoader] = useButtonLoader("Send Now");
  const [notificationFormFields, setNotificationFormFields] = useState({
    isSchedule: false,
  });
  // console.log('notificationFormFields', notificationFormFields)
  const now = new Date();
  const [error, setError] = useState({});


  // Tab button //
  const [tab, setTab] = useState("researcher");

  //*************************** Handle All Functions ******************************//
  // errorHandler
  const errorHandler = () => {
    let isValid = true;
    let error = {};

    if (!notificationFormFields?.title) {
      isValid = false;
      error.title = "Please Enter Title";
    }

    if (!notificationFormFields?.message) {
      isValid = false;
      error.message = "Please Enter Message";
    }
    if (notificationFormFields?.isSchedule && !notificationFormFields?.scheduleDate) {
      isValid = false;
      error.scheduleDate = "Please select schedule date and time";
    }
    setError(error);
    return isValid;
  };

  // onChangeHandler
  const onChangeHandler = (e) => {
    const { name, value, checked } = e.target;
    if (name === "isSchedule") {
      setNotificationFormFields({
        ...notificationFormFields,
        [name]: checked,
      });
    } else {
      setNotificationFormFields({ ...notificationFormFields, [name]: value });
    }
  };

  // update plan handler
  const addNotificationHandler = async (e) => {
    e.preventDefault();
    if (!errorHandler()) return;
    try {
      setButtonLoader(true);
      let sendData = {};
      if (notificationFormFields?.isSchedule) {
        sendData = {
          title: notificationFormFields?.title,
          description: notificationFormFields?.message,
          isScheduled: notificationFormFields?.isSchedule,
          // scheduleDate: dayjs(`${notificationFormFields?.scheduleDate} ${notificationFormFields?.scheduleTime}`).format('MM-DD-YYYY HH:mm')
          scheduleDate: notificationFormFields?.scheduleDate,
        };
      } else {
        sendData = {
          title: notificationFormFields?.title,
          description: notificationFormFields?.message,
          isScheduled: notificationFormFields?.isSchedule,
        };
      }

      const { data } = await createNotificationAPI(sendData);
      console.log('data', data)
      if (data?.code === 200) {
        // toast.success(data?.message);
        navigate(-1);
      } else {
        toast.error(data?.message);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setButtonLoader(false);
    }
  };
  useEffect(() => {
    const isChecked = notificationFormFields?.isSchedule || ''
    if (!isChecked) {
      setNotificationFormFields({ ...notificationFormFields, scheduleDate: '' });
    }
  }, [notificationFormFields?.isSchedule])
  //**************************** Handle HTML CODE ********************************//
  return (
    <div className="create_notification">
        <div className="link-header-holder">
              <p>
                <Link to={-1}>
                <IoChevronBack />
                  Back
                </Link>
                <span>Notification</span>
                &nbsp;
                <span>/ Add Notification</span>
              </p>
            </div>
      <div className="dashboard_title">
        <h3>Add Notification</h3>
      </div>
      <div className="card">
        <div className="card-body">
          <div className="form_field">
            <label className="label">
              Title <small>(max 25 alphabets)</small>
            </label>
            <Input
              type="text"
              name="title"
              maxLength={25}
              placeholder="Enter Title"
              onChange={onChangeHandler}
              value={notificationFormFields?.title}
              error={error?.title}
            />
          </div>
          <div className="form_field">
            <label className="label">Description</label>
            <TextArea
              row="10"
              name="message"
              onChange={onChangeHandler}
              placeholder="Enter Description"
              value={notificationFormFields?.message}
              error={error?.message}
              maxLength={300}
            />

          </div>
          <label className="mb-3">
            <input
              type="checkbox"
              name="isSchedule"
              onChange={onChangeHandler}
              checked={notificationFormFields?.isSchedule}
            />{" "}
            <b>Schedule</b>
          </label>
          {notificationFormFields?.isSchedule && (
            <div className="form_field_wrap">
              <div className="form_field">
                <DatePicker
                  name="scheduleDate"
                  label="Date and Time"
                  selected={notificationFormFields?.scheduleDate}
                  placeholderText="Select date and time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  minDate={new Date()} // block past dates
                  minTime={
                    notificationFormFields?.scheduleDate &&
                      new Date(notificationFormFields.scheduleDate).toDateString() === now.toDateString()
                      ? now
                      : new Date(new Date().setHours(0, 0, 0, 0)) // ✅ fixed here
                  }
                  maxTime={new Date(new Date().setHours(23, 45, 0, 0))} // ✅ fixed here
                  onChange={(date) => setNotificationFormFields({ ...notificationFormFields, scheduleDate: date })}
                  error={error?.scheduleDate}
                />
              </div>
            </div>
          )}
          {/* <div className="form_field">
                <label className="label">Select Date</label>
                <Input
                  type="date"
                  name="scheduleDate"
                  onChange={onChangeHandler}
                  value={notificationFormFields?.scheduleDate}
                />
              </div>
              <div className="form_field">
                <label className="label">Select Time</label>
                <Input
                  type="time"
                  name="scheduleTime"
                  onChange={onChangeHandler}
                  value={notificationFormFields?.scheduleTime}
                />
              </div> */}
          {/* </div> */}


          <div className="form_field">
            <button
              type="button"
              className="button"
              ref={buttonLoader}
              onClick={addNotificationHandler}
            >
              Send Now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNotification;
